import React from 'react'
import { Card, Input, Space, Button } from 'antd'
import { SearchOutlined, DownloadOutlined } from '@ant-design/icons'
import { usePayments } from '../hooks/usePayments'
import { usePaymentActions } from '../hooks/usePaymentActions'
import { useExport } from '../../../shared/hooks/useExport'
import { PaymentsTable } from '../components/PaymentsTable'
import { PaymentDetailsDrawer } from '../components/PaymentDetailsDrawer'
import { RefundModal } from '../components/RefundModal'

export const PaymentsScreen: React.FC = () => {
    const { payments, searchText, setSearchText } = usePayments()
    const { exportToCSV } = useExport()
    const {
        selectedPayment,
        isDetailDrawerOpen,
        isRefundModalOpen,
        handleViewDetails,
        handleOpenRefund,
        handleProcessRefund,
        closeDrawer,
        closeRefundModal
    } = usePaymentActions()

    return (
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
            <Card>
                <Space style={{ marginBottom: 16 }}>
                    <Input
                        placeholder="Search payments..."
                        prefix={<SearchOutlined />}
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                        style={{ width: 300 }}
                    />
                    <Button icon={<DownloadOutlined />} onClick={() => exportToCSV(payments, 'payments-export')}>
                        Export
                    </Button>
                </Space>

                <PaymentsTable
                    payments={payments}
                    onRowClick={handleViewDetails}
                    onRefundClick={handleOpenRefund}
                />
            </Card>

            <PaymentDetailsDrawer
                payment={selectedPayment}
                open={isDetailDrawerOpen}
                onClose={closeDrawer}
                onRefundClick={handleOpenRefund}
            />

            <RefundModal
                payment={selectedPayment}
                open={isRefundModalOpen}
                onCancel={closeRefundModal}
                onFinish={handleProcessRefund}
            />
        </Space>
    )
}
